import Ncs from 'ncs';
import isEmpty from 'lodash/isEmpty'
import castArray from 'lodash/castArray'
import each from 'lodash/each'
import includes from 'lodash/includes'
import qs from 'qs'

const groupsConfig = {}

const frequency_group_order = []
const sulecOrders = [
  {name: 'course', criteria: [{field: 'ncs_documents.course', asc: true}]},
  {name: 'level', criteria: [{field: 'ncs_documents.level', asc: true}]},
  {name: 'sex', criteria: [{field: 'ncs_documents.sex', asc: true}]},
  {name: 'age', criteria: [{field: 'ncs_documents.age', asc: true}]},
  {name: 'mother_tongue', criteria: [{field: 'ncs_documents.mother_tongue', asc: true}]},
  {name: 'age_studying_was_started', criteria: [{field: 'ncs_documents.age_studying_was_started', asc: true}]},
  {name: 'months_abroad', criteria: [{field: 'ncs_documents.months_abroad', asc: true}]}
]

const matchingExpressionsConfig = {
  groups: groupsConfig,
  tokens: {
    groups: ['token', 'category', 'tag', 'lemma', 'unit'],
  }
}

export default {
  elements: {
    types: ['units', 'tokens', 'tasks'],
  },
  categories: {
    patterns: {
      Z: 'Z*',
      W: 'W*',
      I: 'I*',
      JJ: 'JJ*',
      POS: 'POS*',
      RB: 'RB*',
      CC: 'CC*',
      DT: 'DT*',
      N: 'N*',
      RP: 'RP*',
      TO: 'TO*',
      IN: 'IN*',
      P: 'P*',
      F: 'F*',
      V: 'V*'
    }
  },
  filters: {
    values: gon.values,
    dependencyValues: gon.dependencyValues
  },
  result: {
    defaultType: 'kwic',
    types: ['tasks', 'frequency', 'full_frequency', 'kwic', 'matching_expressions'],
    detailTypes: ['context', 'task'],
    error: {
      contactLink: './contact',
      contactEmail: 'support@nlpgo.com'
    },
    kwic: {
      order: {
        orders: [...Ncs.utils.defaultOrder(5), ...sulecOrders],
      },
    },
    full_frequency: {
      groups: groupsConfig,
      frequency_group_order,
    },
    matching_expressions: matchingExpressionsConfig,
    context: {
      tokens: {sourceText: true}
    },
    tasks: {
      endpoint: 'tasks',
      defaultDisplay: 'tasks',
      elements: {
        types: ['tasks'],
        defaultType: 'tasks',
      },
      distances: false,
      order: {
        orders: sulecOrders,
        default: ['level'],
      },
      pagination: true
    },
    task: {
      endpoint: 'task',
      defaultDisplay: 'task',
      elements: {
        types: ['tasks'],
        defaultType: 'tasks',
      },
    }
  },
  download: {
    tasks: [
      {
        name: 'page_download',
        type: 'Page',
        mimeType: 'application/zip',
        filename: 'result.zip',
        pageViewName: 'download'
      }
    ],
    task: [
      {
        name: 'page_download',
        type: 'Page',
        mimeType: 'application/zip',
        filename: 'result.zip',
        pageViewName: 'download'
      }
    ]
  },
  queryLinks: {
    enabled: true,
    stringifyQuery(q, _store) {
      return ''
    },
    parseQuery(s, store) {
      if (isEmpty(s)) return

      const parsed = qs.parse(s, {arrayFormat: 'repeat', decoder: Ncs.utils.decoder})
      const frequencyGroups = castArray(parsed.fg)

      store.dispatch('api/changeResultType', 'matching_expressions')
      store.dispatch('elements/setSearchType', {type: 'tokens'})
      store.dispatch('elements/setElements', {left: [{token: {value: '*'}}], right: [Ncs.config.elements.emptyElement()]})
      store.dispatch('groups/setGroups', parsed.g)
      const allFrequencyGroupValues = Ncs.config.result.matching_expressions.frequency_group_values
      each(allFrequencyGroupValues, (values, group) => {
        if (includes(frequencyGroups, group)) {
          store.commit('frequency_groups/setFrequencyGroupValues', {group, values})
        }
      })
      store.commit('frequency_groups/setFrequencyValues', ['frequency', 'normalized'])
      store.dispatch('api/execute')
    }
  }
}
